module.exports = __webpack_public_path__ + "img/sector_orange.2e3deb60.png";